// Card.jsx

import React from "react";

const Card = ({ title, strongText, description, imgSrc, imgAlt, backgroundColor, reverse }) => {
  return (
    <section className="box-full py-5" style={{ backgroundColor }}>
      <div className="container container_custom">
        <div className="row">
          <div className="col box">
            <div className="inner">
              <div className="inner-content">
                <div className={`row d-flex justify-content-between align-items-center ${reverse ? "flex-row-reverse" : " "}`}>
                <div className="col-lg-6 ml-auto d-flex align-items-center">
                    <img src={imgSrc} alt={imgAlt} className="img-fluid mx-auto" />
                  </div>
                  <div className="col-lg-5">
                    <h3 className="section-title text-left">{title}</h3>
                    <div className="description mt-3">
                      <p><strong>{strongText}</strong></p>
                      <p>{description}</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Card;
